import { useState } from 'react';

export const useModalState = () => {
    const [open, setOpen] = useState(false);

    const handleOpenModal = () => {
        setOpen(true);
    };

    const handleCloseModal = () => {
        setOpen(false);
    };

    return {
        isOpen: open,
        setIsOpen: setOpen,
        openModal: handleOpenModal,
        closeModal: handleCloseModal,
    };
};
